import Vue from "vue";
import menu from "./menu.vue";
import bookDetail from "./bookDetail.vue";
import exhibitionImages from "./exhibitionImages.vue";
import videosPage from "./videos.vue";
import exhibitionArtwork from "./exhibitionArtwork.vue";
import archivesArtwork from "./archivesArtwork.vue";

let loadvm;
export default {
  exhibitionImages:(index,images)=>{
      const constructor = Vue.extend({
        render(h){
            return h(exhibitionImages,{props:{index,images}});
        },
      });
      const vm = new constructor().$mount();
      document.getElementById("app").appendChild(vm.$el);
  },
  exhibitionArtwork:(index,artworks)=>{
    const constructor = Vue.extend({
      render(h){
          return h(exhibitionArtwork,{props:{index,artworks}});
      },
    });
    const vm = new constructor().$mount();
    document.getElementById("app").appendChild(vm.$el);
  },
  archivesArtwork:(id)=>{
    const constructor = Vue.extend({
      render(h){
          return h(archivesArtwork,{props:{id}});
      },
    });
    const vm = new constructor().$mount();
    document.getElementById("app").appendChild(vm.$el);
  },
  videos:(index,videos)=>{
    const constructor = Vue.extend({
      render(h){
          return h(videosPage,{props:{index,videos}});
      },
    });
    const vm = new constructor().$mount();
    document.getElementById("app").appendChild(vm.$el);
  },
  bookDetail:(id)=>{
      const constructor = Vue.extend({
          render(h){
              return h(bookDetail,{props:{id}});
          },
      });
      const vm = new constructor().$mount();
      document.getElementById("app").appendChild(vm.$el);
  },
    openMenu:()=>{
        const constructor = Vue.extend({
            render(h){
                return h(menu,{props:{}});
            },
        });
        const vm = new constructor().$mount();
        document.getElementById("app").appendChild(vm.$el);
    },
}



// WEBPACK FOOTER //
// ./src/components/page/index.js